import React, { useContext } from "react";
import Report from "views/Statistics/Report/Hourly/component";
import ActionsContext from "common/ActionsContext";
import BqnContext from "common/BqnContext";
import {
  parseThroughputPerPolicyIgnoringSubscribers,
  policiesThroughputRetrieval,
} from "./api";
import View from "common/View";
import help from "help/viewThroughputPerPolicy.md";

const enabled = {
  hours: true,
  directions: true,
  policyType: true,
  categories: false,
  target: false,
  output: false,
  filter: false,
};

const policyTypeChoices = [
  { value: "flow", label: "Flow Policies" },
  { value: "rate", label: "Rate Policies" },
  { value: "monitor", label: "Monitor Policies" },
];

const directionsChoices = [
  { value: "downSpeed", label: "Downlink" },
  { value: "upSpeed", label: "Uplink" },
];

const settingsFrom = ({directions = 'downSpeed', policyType = 'flow'}) => ({
  directions: { options: directionsChoices, selected: directions },
  policyType: { options: policyTypeChoices, selected: policyType },
});

const PoliciesThroughputView = ({ returnView = null, ...params}) => {
  const actions = useContext(ActionsContext);
  const settings = settingsFrom(params);
  const { bqnId, clusterStatus } = useContext(BqnContext);
  const mode = clusterStatus?.mode;
  return (
    <View
      title="Policies throughput over time"
      returnView={returnView}
      mdHelp={help}
    >
      <Report
        returnView={returnView}
        from="timeline"
        itemsFrom="policies"
        itemsValueFrom={({ directions }) =>
          directions || settings.directions.defautValue
        }
        yAxisUnits="Mbps"
        provider={({ hours, policyType }) =>
          policiesThroughputRetrieval({ hours, type: policyType, mode, bqnId })
            .then(parseThroughputPerPolicyIgnoringSubscribers)
            .catch((error) => console.error(error) || error)}
        actions={actions}
        settings={settings}
        enabled={enabled}
        noDataMessage="No throughput per policies data"
      />
    </View>
  );
}

export default PoliciesThroughputView;
